import React, { lazy, Suspense, useEffect, useState } from 'react';
import { StickyHeader } from './components/StickyHeader';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
const DeferredLanding = lazy(() => import('./components/DeferredLanding').then(({
  DeferredLanding: Component
}) => ({
  default: Component
})));
export function App() {
  const [loadDeferredContent, setLoadDeferredContent] = useState(false);
  useEffect(() => {
    document.title = 'The Young Inventor Lab™ | 120 Hands-On STEM Builds for Kids Ages 5–12';
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', 'A printable library of 120 hands-on STEM builds for curious kids ages 5–12, using simple household and recycled materials. Five printable volumes, five maker bonuses, instant digital access.');
    const timer = window.setTimeout(() => setLoadDeferredContent(true), 900);
    return () => window.clearTimeout(timer);
  }, []);
  return <div className="w-full bg-ivory text-navy" data-id="element-0" data-mp="3rd1all5o5hp3">
      <StickyHeader data-id="element-1" data-mp="6hrlipoilfp" />
      <main data-id="element-2" data-mp="4wx1t3d72hu">
        <span id="hero-sentinel" aria-hidden="true" data-id="element-3" data-mp="5gez9t0lqvv" />
        <Hero data-id="element-4" data-mp="2zld2jatxbhc2" />
        <TrustBar data-id="element-5" data-mp="2zlv7cvunj3vl" />
        {loadDeferredContent && <Suspense fallback={<div className="h-10 bg-ivory" aria-hidden="true" data-id="element-7" data-mp="33moqzd129wio" />} data-id="element-6" data-mp="2zn678kkz7rhf">
            <DeferredLanding data-id="element-8" data-mp="33myl9ct52pu6" />
          </Suspense>}
      </main>
    </div>;
}